import { useMemo } from 'react';
import { useTranslation } from '@frontend/i18n';
import { HiddenFilterKeys, InboxFilters } from '@frontend/inbox-filters';
import { Text, TextProps } from '@frontend/design-system';

type InboxStatusFiltersTextProps = Omit<TextProps, 'children'> & {
  filters: InboxFilters;
  hideFilters: HiddenFilterKeys;
};

export const InboxStatusFiltersText = ({ hideFilters = [], filters, ...props }: InboxStatusFiltersTextProps) => {
  const { t } = useTranslation('inbox');

  const text = useMemo(() => {
    const arr: string[] = [];

    if (!hideFilters.includes('tags') && filters.tags.length) {
      arr.push(t('{{count}} tags', { count: filters.tags.length }));
    }

    if (!hideFilters.includes('locationPhones') && !!filters.locationPhones?.length) {
      arr.push(t('{{count}} office phones', { count: filters.locationPhones?.length }));
    }

    return arr.join(', ');
  }, [filters.locationPhones?.length, filters.tags.length, hideFilters, t]);

  if (!text) return null;

  return (
    <Text color='primary' size='small' {...props}>
      {text}
    </Text>
  );
};
